<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit Holidays Schedule Info Form"
      id="owner_view_holidays_schedule_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="holidays_schedules_form_ref"
      id="holidays_schedules_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row
        no-gutterss
        class="pa-0 mb-2 mt-4 align-center"
        v-for="(form_holiday_day, index) in form"
        :key="index"
        style="border-bottom: 1px solid #ccc"
      >
        <v-col cols="12" no-gutters class="pb-0 pt-0 mb-0">
          <div class="d-flex justify-space-between text-left">
            <b class="mr-4 wdth-200">{{ form_holiday_day.holiday.name }}</b>
            <b class="mr-6">{{
              date_to_words(form_holiday_day.holiday.starts_on)
            }}</b>
            <div class="flex-grow-1">
              {{ form_holiday_day.holiday.description }}
            </div>
          </div>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <div class="d-flex justify-space-between text-left">
            <b>Openning Time:</b>
            <span
              :class="
                form_holiday_day.opens == 'closed'
                  ? 'red--text'
                  : 'primary--text'
              "
              ><b>{{ form_holiday_day.opens }}</b>
              <small v-if="form_holiday_day.opens != 'closed'"
                >(12hr)</small
              ></span
            >
          </div>
          <TimeField
            :label="'in 24hr clock'"
            v-model="form_holiday_day.opens"
            :validation_rules="[]"
            :disabled="is_loading"
            value_format="ampm"
          ></TimeField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <div class="d-flex justify-space-between text-left">
            <b>Closing Time:</b>
            <span
              :class="
                form_holiday_day.closes == 'closed'
                  ? 'red--text'
                  : 'primary--text'
              "
              ><b>{{ form_holiday_day.closes }}</b>
              <small v-if="form_holiday_day.closes != 'closed'"
                >(12hr)</small
              ></span
            >
          </div>
          <TimeField
            :label="'in 24hr clock'"
            v-model="form_holiday_day.closes"
            :validation_rules="[]"
            :disabled="is_loading"
            value_format="ampm"
          ></TimeField>
        </v-col>
        <v-col cols="2">
          <v-btn
            class="mr-4"
            :disabled="is_loading"
            color="primary"
            @click="on_set_closed(index)"
          >
            set closed
          </v-btn>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TimeField from "../../../components/TimeField";
export default {
  name: "OwnerBusinessesManageHolidaysSchedule",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    TimeField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: [],
    };
  },
  methods: {
    on_set_closed(index_target) {
      for (var index = 0; index < this.form.length; index++) {
        if (parseInt(index_target) == index) {
          this.form[index].opens = "closed";
          this.form[index].closes = "closed";
          break;
        }
      }
    },
    date_to_words(dt_str) {
      return Utils.date_str_to_words(dt_str);
    },
    on_auto_fill() {
      var form_items = [];
      if (this.business && this.business.app_holidays) {
        //index the business holiday entries
        var indexed_business_holidays = {};
        for (
          var index = 0;
          index < this.business.business_holliday_schedules.length;
          index++
        ) {
          var schedule = this.business.business_holliday_schedules[index];
          indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
        }
        //go through the application holidays config
        for (
          var index = 0;
          index < this.business.app_holidays.length;
          index++
        ) {
          var holiday = this.business.app_holidays[index];
          var dt = "";
          if (holiday.starts_on == holiday.ends_on) {
            dt = Utils.date_str_to_words(holiday.starts_on);
          } else {
            dt = Utils.date_str_to_words(holiday.starts_on);
            //+
            // " - " +
            // Utils.date_str_to_words(holiday.ends_on);
          }

          var ov = "";
          var cv = "";
          //look for this holiday from the business object
          if (indexed_business_holidays[parseInt(holiday.id)]) {
            var schedule = indexed_business_holidays[parseInt(holiday.id)];
            ov = schedule.opens;
            cv = schedule.closes;
          }

          form_items.push({
            holiday: holiday,
            business_id: this.business.id,
            holliday_id: holiday.id,
            opens: ov.length > 0 ? ov : "08:00 AM",
            closes: cv.length > 0 ? cv : "01:00 PM",
            opens_time: 0,
            ends_time: 0,
          });
        }
      }
      this.form = form_items;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      var form_items = [];
      if (this.business && this.business.app_holidays) {
        //index the business holiday entries
        var indexed_business_holidays = {};
        for (
          var index = 0;
          index < this.business.business_holliday_schedules.length;
          index++
        ) {
          var schedule = this.business.business_holliday_schedules[index];
          indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
        }
        //go through the application holidays config
        for (
          var index = 0;
          index < this.business.app_holidays.length;
          index++
        ) {
          var holiday = this.business.app_holidays[index];
          var dt = "";
          if (holiday.starts_on == holiday.ends_on) {
            dt = Utils.date_str_to_words(holiday.starts_on);
          } else {
            dt = Utils.date_str_to_words(holiday.starts_on);
            //+
            // " - " +
            // Utils.date_str_to_words(holiday.ends_on);
          }

          var ov = "";
          var cv = "";
          //look for this holiday from the business object
          if (indexed_business_holidays[parseInt(holiday.id)]) {
            var schedule = indexed_business_holidays[parseInt(holiday.id)];
            ov = schedule.opens;
            cv = schedule.closes;
          }

          form_items.push({
            holiday: holiday,
            business_id: this.business_id,
            holliday_id: holiday.id,
            opens: ov.length > 0 ? ov : "00:00 AM",
            closes: cv.length > 0 ? cv : "00:00 AM",
            opens_time: 0,
            ends_time: 0,
          });
        }
      }
      this.form = form_items;
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.locations_form_ref.show_error_dialog();
        }
      );
    },
    submit() {
      //validate the entries
      // if either is closed both should be closed
      var val_errors = [];
      var data_to_send = [];
      for (var index = 0; index < this.form.length; index++) {
        var entry = this.form[index];
        var open_time = entry.opens;
        var close_time = entry.closes;
        if(open_time == "closed" && close_time != "closed"){
          val_errors.push(entry.holiday.name + ": If openning time is closed, also closing time should be closed");
        }else if(close_time == "closed" && open_time != "closed"){
          val_errors.push(entry.holiday.name + ": If closing time is closed, also openning time should be closed");
        }
        var open_time_val = parseFloat(open_time.replace("AM","").replace("PM","").replace("closed","0.0").trim().replace(":",".").trim());
        if(open_time.indexOf("PM") > -1){
          open_time_val = open_time_val + 12;
        }
        var close_time_val = parseFloat(close_time.replace("AM","").replace("PM","").replace("closed","0.0").trim().replace(":",".").trim());
        if(close_time.indexOf("PM") > -1){
          close_time_val = close_time_val + 12;
        }
        if(open_time_val  > close_time_val){
          val_errors.push(entry.holiday.name + ": Openning time cannot be greater than closing time ");
        }
        data_to_send.push({
            business_id: entry.business_id,
            holliday_id: entry.holiday.id,
            opens: entry.opens,
            closes: entry.closes,
            opens_time: open_time_val,
            ends_time: close_time_val
        });
      }

      if(val_errors.length > 0){
        this.errors = val_errors;
        this.$refs.holidays_schedules_form_ref.show_error_dialog();
        return false;
      }

      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.update_holidays_schedule({
        id: this.business_id,
        data: data_to_send
      },(res) => {
        this.$emit("on-hide-loader");
        this.message =
          "<b>Operation was successfull</b> <br/> Your business holidays schedule information has been updated successfully";
        this.$refs.holidays_schedules_form_ref.show_message_dialog();
      }, (errors) => {
        this.errors = errors;
        this.$refs.holidays_schedules_form_ref.show_error_dialog();
        this.$emit("on-hide-loader");
      });

    },
    on_hide_message() {
        this.load_business(this.business_id);
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Holidays Schedule Info",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Holidays",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/holidaysschedule/manage",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_holidays_schedule_edit_form", options);
  },
};
</script>